
const setSelectValue = (title, hbw, silent = false) => {
  const priceGroupSelect = document.querySelector(".CP__presigruppe-theme-select");
  const priceGroupSelectOptions = document.querySelectorAll(".CP__presigruppe-theme-select option");

  let valueSet = false;

  priceGroupSelectOptions.forEach((option) => {
    const hbwmax = parseFloat(option.dataset.hbwmax);
    const hbwmin = parseFloat(option.dataset.hbwmin);

    if (hbw >= hbwmin && hbw <= hbwmax) {
      const value = option.value;
      priceGroupSelect.value = value;
      valueSet = true;

      if (!silent) {
        priceGroupSelect.dispatchEvent(new Event("change"));

        const variantSelects = document.querySelector("variant-selects");
        if (variantSelects) {
          variantSelects.dispatchEvent(new Event("change"));
        }
      }
    }
  });

  if (!valueSet) {
    console.warn("No matching option found for hbw:", hbw);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  let allColors = [];

  // RAL Classic official German names
  const ralNames = {
    1000:'Grünbeige',1001:'Beige',1002:'Sandgelb',1003:'Signalgelb',1004:'Goldgelb',
    1005:'Honiggelb',1006:'Maisgelb',1007:'Narzissengelb',1011:'Braunbeige',1012:'Zitronengelb',
    1013:'Perlweiß',1014:'Elfenbein',1015:'Hellelfenbein',1016:'Schwefelgelb',1017:'Safrangelb',
    1018:'Zinkgelb',1019:'Graubeige',1020:'Olivgelb',1021:'Rapsgelb',1023:'Verkehrsgelb',
    1024:'Ockergelb',1027:'Currygelb',1028:'Melonengelb',1032:'Ginstergelb',1033:'Dahliengelb',
    1034:'Pastellgelb',1037:'Sonnengelb',
    2000:'Gelborange',2001:'Rotorange',2002:'Blutorange',2003:'Pastellorange',2004:'Reinorange',
    2008:'Hellrotorange',2009:'Verkehrsorange',2010:'Signalorange',2011:'Tieforange',2012:'Lachsorange',
    2017:'RAL Orange',
    3000:'Feuerrot',3001:'Signalrot',3002:'Karminrot',3003:'Rubinrot',3004:'Purpurrot',
    3005:'Weinrot',3007:'Schwarzrot',3009:'Oxidrot',3011:'Braunrot',3012:'Beigerot',
    3013:'Tomatenrot',3014:'Altrosa',3015:'Hellrosa',3016:'Korallenrot',3017:'Rosé',
    3018:'Erdbeerrot',3020:'Verkehrsrot',3022:'Lachsrot',3027:'Himbeerrot',3028:'Reinrot',
    3031:'Orientrot',
    4001:'Rotlila',4002:'Rotviolett',4003:'Erikaviolett',4004:'Bordeauxviolett',4005:'Blaulila',
    4006:'Verkehrspurpur',4007:'Purpurviolett',4008:'Signalviolett',4009:'Pastellviolett',4010:'Telemagenta',
    5000:'Violettblau',5001:'Grünblau',5002:'Ultramarinblau',5003:'Saphirblau',5004:'Schwarzblau',
    5005:'Signalblau',5007:'Brillantblau',5008:'Graublau',5009:'Azurblau',5010:'Enzianblau',
    5011:'Stahlblau',5012:'Lichtblau',5013:'Kobaltblau',5014:'Taubenblau',5015:'Himmelblau',
    5017:'Verkehrsblau',5018:'Türkisblau',5019:'Capriblau',5020:'Ozeanblau',5021:'Wasserblau',
    5022:'Nachtblau',5023:'Fernblau',5024:'Pastellblau',
    6000:'Patinagrün',6001:'Smaragdgrün',6002:'Laubgrün',6003:'Olivgrün',6004:'Blaugrün',
    6005:'Moosgrün',6006:'Grauoliv',6007:'Flaschengrün',6008:'Braungrün',6009:'Tannengrün',
    6010:'Grasgrün',6011:'Resedagrün',6012:'Schwarzgrün',6013:'Schilfgrün',6014:'Gelboliv',
    6015:'Schwarzoliv',6016:'Türkisgrün',6017:'Maigrün',6018:'Gelbgrün',6019:'Weißgrün',
    6020:'Chromoxidgrün',6021:'Blaßgrün',6022:'Braunoliv',6024:'Verkehrsgrün',6025:'Farngrün',
    6026:'Opalgrün',6027:'Lichtgrün',6028:'Kieferngrün',6029:'Minzgrün',6032:'Signalgrün',
    6033:'Minttürkis',6034:'Pastelltürkis',6037:'Reingrün',
    7000:'Fehgrau',7001:'Silbergrau',7002:'Olivgrau',7003:'Moosgrau',7004:'Signalgrau',
    7005:'Mausgrau',7006:'Beigegrau',7008:'Khakigrau',7009:'Grüngrau',7010:'Zeltgrau',
    7011:'Eisengrau',7012:'Basaltgrau',7013:'Braungrau',7015:'Schiefergrau',7016:'Anthrazitgrau',
    7021:'Schwarzgrau',7022:'Umbragrau',7023:'Betongrau',7024:'Graphitgrau',7026:'Granitgrau',
    7030:'Steingrau',7031:'Blaugrau',7032:'Kieselgrau',7033:'Zementgrau',7034:'Gelbgrau',
    7035:'Lichtgrau',7036:'Platingrau',7037:'Staubgrau',7038:'Achatgrau',7039:'Quarzgrau',
    7040:'Fenstergrau',7042:'Verkehrsgrau A',7043:'Verkehrsgrau B',7044:'Seidengrau',
    7045:'Telegrau 1',7046:'Telegrau 2',7047:'Telegrau 4',
    8000:'Grünbraun',8001:'Ockerbraun',8002:'Signalbraun',8003:'Lehmbraun',8004:'Kupferbraun',
    8007:'Rehbraun',8008:'Olivbraun',8011:'Nußbraun',8012:'Rotbraun',8014:'Sepiabraun',
    8015:'Kastanienbraun',8016:'Mahagonibraun',8017:'Schokoladenbraun',8019:'Graubraun',
    8022:'Schwarzbraun',8023:'Orangebraun',8024:'Beigebraun',8025:'Blaßbraun',8028:'Terrabraun',
    9001:'Cremeweiß',9002:'Grauweiß',9003:'Signalweiß',9004:'Signalschwarz',9005:'Tiefschwarz',
    9006:'Weißaluminium',9007:'Graualuminium',9010:'Reinweiß',9011:'Graphitschwarz',
    9012:'Reinraumweiß',9016:'Verkehrsweiß',9017:'Verkehrsschwarz',9018:'Papyrusweiß'
  };

  // ── Classification: Brillux code → broad family ──

  const parseBrillux = (title) => {
    const m = title.match(/^(\d{2})\.(\d{2}|ME)\.(\d{2})/);
    if (!m) return null;
    return { xx: parseInt(m[1]), yy: m[2] === 'ME' ? 'ME' : parseInt(m[2]), zz: parseInt(m[3]) };
  };

  // 21 fine families → 8 broad families
  const broadFamilyMap = {
    'weiss':'grau','schwarz':'grau','hellgrau':'grau','dunkelgrau':'grau',
    'braun':'braun','dunkelbraun':'braun',
    'gelb':'gelb','hellorange':'gelb','dunkelorange':'gelb',
    'rot':'rot','rosa':'rot','pink':'rot',
    'hellviolett':'violett','dunkelviolett':'violett',
    'hellblau':'blau','dunkelblau':'blau',
    'helltuerkis':'tuerkis','dunkeltuerkis':'tuerkis',
    'hellgruen':'gruen','dunkelgruen':'gruen'
  };

  // RAL number group → broad family (fixes ~23 boundary misclassifications)
  const ralBroadFamily = (ralNumber) => {
    const group = Math.floor(ralNumber / 1000);
    const map = { 1:'gelb', 2:'gelb', 3:'rot', 4:'violett', 5:'blau', 6:'gruen', 7:'grau', 8:'braun', 9:'grau' };
    return map[group] || null;
  };

  // Ported from brillux-sim.js — classifies by Brillux code XX.YY.ZZ
  const classifyByBrillux = (xx, yy, zz) => {
    const sat = (yy === 'ME') ? 4 : yy;

    // Achromatic
    if (xx === 99) {
      if (zz <= 9) return 'weiss';
      if (zz <= 18) return 'hellgrau';
      if (zz <= 36) return 'dunkelgrau';
      return 'schwarz';
    }

    // Neutral gray with green/teal tendency (75)
    if (xx === 75) {
      if (sat >= 12) return zz <= 18 ? 'helltuerkis' : 'dunkeltuerkis';
      if (sat >= 9) return zz <= 18 ? 'hellgrau' : 'dunkelgrau';
      if (zz <= 3) return 'weiss';
      if (zz <= 18) return 'hellgrau';
      if (zz <= 30) return 'dunkelgrau';
      return 'schwarz';
    }

    // Neutral with green/teal tendency (78)
    if (xx === 78) {
      if (sat >= 6) return zz <= 18 ? 'hellgruen' : 'dunkelgruen';
      if (zz <= 3) return 'weiss';
      if (zz <= 18) return 'hellgrau';
      if (zz <= 30) return 'dunkelgrau';
      return 'schwarz';
    }

    // Warm gray with olive/green tendency (81)
    if (xx === 81) {
      if (sat >= 9) return zz <= 18 ? 'hellgruen' : 'dunkelgruen';
      if (sat >= 6) return zz <= 18 ? 'hellgrau' : 'dunkelgruen';
      return zz <= 18 ? 'hellgrau' : 'dunkelgrau';
    }

    // Cool hues at very low sat → gray
    if ([42, 45, 48, 51, 57, 60, 63].includes(xx) && sat <= 6) {
      if (zz <= 3) return 'weiss';
      if (zz <= 18) return 'hellgrau';
      if (zz <= 30) return 'dunkelgrau';
      return 'schwarz';
    }

    // Olive/green-grays (84, 87)
    if (xx === 84 || xx === 87) {
      if (sat <= 6) return zz <= 18 ? 'hellgrau' : 'dunkelgruen';
      return zz <= 18 ? 'hellgruen' : 'dunkelgruen';
    }

    // Warm hues very low sat → braun
    if (xx >= 3 && xx <= 21 && sat <= 6) {
      if (zz <= 21) return 'braun';
      if (zz <= 30) return 'dunkelbraun';
      return 'schwarz';
    }

    // Cool hues very low sat → gray (except 33-39 which have violet tint)
    if (sat <= 3) {
      if (xx >= 33 && xx <= 39) return zz <= 18 ? 'hellviolett' : 'dunkelviolett';
      if (zz <= 18) return 'hellgrau';
      if (zz <= 30) return 'dunkelgrau';
      return 'schwarz';
    }

    // ── Chromatic colors (sat >= 4-7+) ──

    // Warm yellow (03)
    if (xx === 3) {
      if (sat >= 9) return zz <= 18 ? 'gelb' : 'braun';
      return zz <= 12 ? 'gelb' : 'braun';
    }

    // Yellow-orange (06)
    if (xx === 6) {
      if (sat >= 12) {
        if (zz <= 15) return 'gelb';
        if (zz <= 18) return 'hellorange';
        return 'dunkelbraun';
      }
      if (sat >= 9) {
        if (zz <= 9) return 'gelb';
        return zz <= 18 ? 'braun' : 'dunkelbraun';
      }
      return zz <= 21 ? 'braun' : 'dunkelbraun';
    }

    // Orange (09)
    if (xx === 9) {
      if (sat >= 15) {
        if (zz <= 9) return 'gelb';
        if (zz <= 18) return 'hellorange';
        return 'dunkelbraun';
      }
      if (sat >= 12) {
        if (zz <= 6) return 'gelb';
        if (zz <= 15) return 'hellorange';
        return 'dunkelbraun';
      }
      if (sat >= 9) return zz <= 18 ? 'braun' : 'dunkelbraun';
      return zz <= 12 ? 'braun' : 'dunkelbraun';
    }

    // Red-orange (12)
    if (xx === 12) {
      if (sat >= 15) {
        if (zz <= 9) return 'hellorange';
        if (zz <= 18) return 'dunkelorange';
        return 'dunkelbraun';
      }
      if (sat >= 12) {
        if (zz <= 12) return 'hellorange';
        if (zz <= 18) return 'dunkelorange';
        return 'dunkelbraun';
      }
      if (sat >= 9) return zz <= 18 ? 'braun' : 'dunkelbraun';
      return zz <= 18 ? 'braun' : 'dunkelbraun';
    }

    // Red (15) — dark high-sat still looks brown
    if (xx === 15) {
      if (sat >= 12) {
        if (zz <= 9) return 'rosa';
        if (zz <= 18) return 'rot';
        return 'dunkelbraun';
      }
      return zz <= 12 ? 'braun' : 'dunkelbraun';
    }

    // Red-pink (18) — dark high-sat still looks brown
    if (xx === 18) {
      if (sat >= 12) {
        if (zz <= 9) return 'rosa';
        if (zz <= 18) return 'rot';
        return 'dunkelbraun';
      }
      return zz <= 18 ? 'braun' : 'dunkelbraun';
    }

    // Pink/rose (21) — dark high-sat still looks brown
    if (xx === 21) {
      if (sat >= 12) {
        if (zz <= 12) return 'rosa';
        if (zz <= 18) return 'rot';
        return 'dunkelbraun';
      }
      return zz <= 18 ? 'braun' : 'dunkelbraun';
    }

    // Magenta (24) — dark high-sat still looks brown
    if (xx === 24) {
      if (sat >= 12) {
        if (zz <= 12) return 'pink';
        if (zz <= 18) return 'rot';
        return 'dunkelbraun';
      }
      return zz <= 18 ? 'braun' : 'dunkelbraun';
    }

    // Red / pink (27, 30, 33, 36, 39)
    if (xx >= 27 && xx <= 39) {
      if (sat <= 6) {
        // 33-39 at low sat: mauve/violet tint
        if (xx >= 33) return zz <= 18 ? 'hellviolett' : 'dunkelviolett';
        // 27-30 at low sat: neutral gray
        return zz <= 18 ? 'hellgrau' : 'dunkelgrau';
      }
      // 33-39 at sat 7-9: mauve tint → violett
      if (sat <= 9 && xx >= 33) return zz <= 18 ? 'hellviolett' : 'dunkelviolett';
      // All else (sat >= 10): rosa/rot, dark split by hue + sat
      if (zz <= 12) return 'rosa';
      if (zz <= 18) return 'rot';
      // Dark: 33-39 lean purple/plum
      if (xx >= 33) return 'dunkelviolett';
      // Dark 27-30: high sat still red, low sat turns brown
      return sat >= 15 ? 'rot' : 'dunkelbraun';
    }

    // Violet-purple (42, 45, 48, 51)
    if (xx === 42 || xx === 45 || xx === 48 || xx === 51) return zz <= 18 ? 'hellviolett' : 'dunkelviolett';

    // Blue (54, 57)
    if (xx === 54 || xx === 57) return zz <= 18 ? 'hellblau' : 'dunkelblau';

    // Blue-gray (60, 63) high sat
    if (xx === 60 || xx === 63) return zz <= 18 ? 'hellblau' : 'dunkelblau';

    // Steel blue (66, 69)
    if (xx === 66 || xx === 69) return zz <= 18 ? 'hellblau' : 'dunkelblau';

    // Teal-gray (72)
    if (xx === 72) {
      if (sat <= 6) return zz <= 18 ? 'hellgrau' : 'dunkelgrau';
      return zz <= 18 ? 'helltuerkis' : 'dunkeltuerkis';
    }

    // Yellow-green (90)
    if (xx === 90) {
      if (sat <= 6) return zz <= 18 ? 'hellgrau' : 'dunkelgrau';
      return zz <= 18 ? 'hellgruen' : 'dunkelgruen';
    }

    // Warm yellow-green (93)
    if (xx === 93) {
      if (sat <= 6) return zz <= 18 ? 'braun' : 'dunkelgruen';
      if (sat >= 12) return zz <= 18 ? 'gelb' : 'dunkelgruen';
      if (zz <= 12) return 'gelb';
      return zz <= 18 ? 'hellgruen' : 'dunkelgruen';
    }

    // Cool yellow (96)
    if (xx === 96) {
      if (sat <= 6) return zz <= 18 ? 'braun' : 'dunkelgruen';
      if (sat <= 9) return zz <= 12 ? 'gelb' : (zz <= 18 ? 'hellgruen' : 'dunkelgruen');
      return zz <= 18 ? 'gelb' : 'dunkelgruen';
    }

    return 'other';
  };

  // Display config for broad families
  const broadFamilyNames = {
    'grau': 'Grau & Schwarz',
    'braun': 'Braun & Beige',
    'gelb': 'Gelb & Orange',
    'rot': 'Rot & Rosa',
    'violett': 'Violett',
    'blau': 'Blau',
    'tuerkis': 'Türkis',
    'gruen': 'Grün'
  };

  const broadFamilyGradients = {
    'ral': 'conic-gradient(red,yellow,green,cyan,blue,magenta,red)',
    'grau': 'linear-gradient(135deg, #e0e0e0 25%, #808080 50%, #333 75%)',
    'braun': 'linear-gradient(135deg, #e8d5b7 25%, #a67c52 50%, #5c3a1e 75%)',
    'gelb': 'linear-gradient(135deg, #fff176 25%, #ffd700 50%, #ff8c00 75%)',
    'rot': 'linear-gradient(135deg, #f5b0b0 25%, #dc143c 50%, #8b0000 75%)',
    'violett': 'linear-gradient(135deg, #dda0dd 25%, #8b008b 50%, #4b0082 75%)',
    'blau': 'linear-gradient(135deg, #b0d4f1 25%, #4169e1 50%, #00008b 75%)',
    'tuerkis': 'linear-gradient(135deg, #7fffd4 25%, #40e0d0 50%, #005f5f 75%)',
    'gruen': 'linear-gradient(135deg, #90ee90 25%, #228b22 50%, #1b5e20 75%)'
  };

  const intensityNames = { 'hell': 'Hell', 'mittel': 'Mittel', 'dunkel': 'Dunkel' };

  // ── DOM elements ──
  const defaultState = document.getElementById('cp-default-state');
  const pickerPanel = document.getElementById('cp-picker');
  const step1 = document.getElementById('cp-step1');
  const step2 = document.getElementById('cp-step2');
  const step3 = document.getElementById('cp-step3');
  const colorPicker = document.getElementById('color-picker'); // hidden input
  const colorList = document.getElementById('color-list');
  const searchInput = document.getElementById('cp-search-input');
  const searchResults = document.getElementById('cp-search-results');

  let currentBroadFamily = null;
  let currentIntensity = null;
  let isSelectingColor = false;
  let selectedColor = null;
  let pickerVisible = false;

  // ── Helpers ──

  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };

  const getBrightness = (hex) => {
    const rgb = hexToRgb(hex);
    if (!rgb) return 128;
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  };

  const getIntensity = (hbw) => {
    if (hbw >= 55) return 'hell';
    if (hbw >= 25) return 'mittel';
    return 'dunkel';
  };

  const isColorAvailable = (hbw) => {
    const options = document.querySelectorAll(".CP__presigruppe-theme-select option");
    for (let option of options) {
      const hbwmax = parseFloat(option.dataset.hbwmax);
      const hbwmin = parseFloat(option.dataset.hbwmin);
      if (hbw >= hbwmin && hbw <= hbwmax) {
        return option.getAttribute('data-variant-option-available') === 'true';
      }
    }
    return false;
  };

  // ── Price extraction ──

  const getProductData = () => {
    // Empire v4: product JSON in section data script
    const scripts = document.querySelectorAll('script[data-section-data]');
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data.product && data.product.variants) return data.product;
      } catch (e) {}
    }
    // Fallback: any JSON with variants
    const allScripts = document.querySelectorAll('script[type="application/json"]');
    for (const script of allScripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data.variants && data.id) return data;
      } catch (e) {}
    }
    return null;
  };

  const getCurrentSizeOption = () => {
    const selectedPill = document.querySelector('.variant-pill--selected');
    return selectedPill ? selectedPill.getAttribute('data-pill-value') : null;
  };

  const getTierPrices = () => {
    const product = getProductData();
    if (!product) return {};

    const currentSize = getCurrentSizeOption();
    if (!currentSize) return {};

    const prices = {};
    const preisOptions = document.querySelectorAll('.CP__presigruppe-theme-select option');

    preisOptions.forEach(opt => {
      if (!opt.dataset.hbwmin) return;
      const hbwmin = parseFloat(opt.dataset.hbwmin);

      let tierKey;
      if (hbwmin >= 85) tierKey = 'weiss';
      else if (hbwmin >= 55) tierKey = 'hell';
      else if (hbwmin >= 25) tierKey = 'mittel';
      else tierKey = 'dunkel';

      const tierValue = opt.value;
      if (tierValue === 'not-selected') return;

      // Find variant matching this size + preisgruppe
      const variant = product.variants.find(v => {
        // Size is typically option1, Preisgruppe is option2
        return (v.option1 === currentSize && v.option2 === tierValue) ||
               (v.option2 === currentSize && v.option1 === tierValue);
      });

      if (variant && variant.available !== false) {
        if (!prices[tierKey]) {
          prices[tierKey] = { min: variant.price, max: variant.price };
        } else {
          prices[tierKey].min = Math.min(prices[tierKey].min, variant.price);
          prices[tierKey].max = Math.max(prices[tierKey].max, variant.price);
        }
      }
    });

    return prices;
  };

  const formatPrice = (tierPrice) => {
    if (!tierPrice) return '';
    const euros = (tierPrice.min / 100).toFixed(2).replace('.', ',');
    const hasVariance = tierPrice.min !== tierPrice.max;
    return hasVariance ? `ab ${euros} €` : `${euros} €`;
  };

  const formatDelta = (tierPrice, basePrice) => {
    if (!tierPrice) return '';
    if (!basePrice) return formatPrice(tierPrice);
    const deltaCents = tierPrice.min - basePrice.min;
    const delta = (deltaCents / 100).toFixed(2).replace('.', ',');
    const hasVariance = tierPrice.min !== tierPrice.max;
    return hasVariance ? `ab +${delta} €` : `+${delta} €`;
  };

  // Direct price-display update — fallback for contexts where Empire's variant-change
  // pipeline doesn't fire (e.g. dynamic-featured-product on the homepage).
  // Finds the variant matching current size + color tier and writes its prices into
  // the visible price elements within the picker's section scope.
  const findMatchedVariantForColor = (color) => {
    const product = getProductData();
    if (!product) return null;
    const currentSize = getCurrentSizeOption();
    if (!currentSize) return null;

    const opts = document.querySelectorAll('.CP__presigruppe-theme-select option');
    let tierValue = null;
    for (const opt of opts) {
      if (opt.value === 'not-selected') continue;
      const hbwmin = parseFloat(opt.dataset.hbwmin);
      const hbwmax = parseFloat(opt.dataset.hbwmax);
      if (color.hbw >= hbwmin && color.hbw <= hbwmax) {
        tierValue = opt.value;
        break;
      }
    }
    if (!tierValue) return null;

    return product.variants.find(v => {
      return (v.option1 === currentSize && v.option2 === tierValue) ||
             (v.option2 === currentSize && v.option1 === tierValue);
    }) || null;
  };

  const formatMoneyDe = (cents) => {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  const updatePriceDisplay = (variant) => {
    if (!variant) return;
    const picker = document.querySelector('.CP__wrapper');
    const scope = (picker && picker.closest('section, [data-product-wrapper]')) || document;

    scope.querySelectorAll('[data-price-container] [data-price]').forEach(el => {
      el.innerHTML = formatMoneyDe(variant.price);
    });

    if (variant.unit_price) {
      const refUnit = (variant.unit_price_measurement && variant.unit_price_measurement.reference_unit) || 'l';
      scope.querySelectorAll('[data-unit-price-amount]').forEach(el => {
        el.innerHTML = formatMoneyDe(variant.unit_price);
      });
      scope.querySelectorAll('[data-unit-price-measure]').forEach(el => {
        el.innerHTML = refUnit;
      });
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      scope.querySelectorAll('[data-price-compare-container] [data-price-compare]').forEach(el => {
        el.innerHTML = formatMoneyDe(variant.compare_at_price);
      });
    }

    // Ensure cart submission uses the new variant id even if Empire's pipeline didn't fire
    const formArea = scope.querySelector('[data-product-form-area]') || scope;
    const masterInput = formArea.querySelector('input[name="id"]');
    if (masterInput && masterInput.value !== String(variant.id)) {
      masterInput.value = variant.id;
      masterInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  // ── Load colors ──

  const loadColors = () => {
    const colorsElement = document.getElementById("colors");
    if (!colorsElement) return;

    const colorsObj = JSON.parse(colorsElement.textContent);
    allColors = [];

    for (let prop in colorsObj) {
      const color = colorsObj[prop];
      const hex = color["hex-code"];
      const hbw = parseFloat(color.hbw.replace(',', '.'));
      const ralMatch = color.title.match(/ral\s*(\d{4})/i);
      const ralNumber = ralMatch ? parseInt(ralMatch[1]) : null;
      const ralName = ralNumber ? ralNames[ralNumber] || null : null;

      // Classify: Brillux code → fine family → broad family
      let broadFamily = 'grau';
      if (color.title === 'Weiss') {
        broadFamily = 'grau';
      } else {
        const parsed = parseBrillux(color.title);
        if (parsed) {
          const fineFamily = classifyByBrillux(parsed.xx, parsed.yy, parsed.zz);
          broadFamily = broadFamilyMap[fineFamily] || 'grau';
        }
      }

      // RAL override: use official RAL group for broad family
      if (ralNumber) {
        const ralOverride = ralBroadFamily(ralNumber);
        if (ralOverride) broadFamily = ralOverride;
      }

      const intensity = getIntensity(hbw);

      allColors.push({
        title: color.title,
        hex: hex,
        hbw: hbw,
        broadFamily: broadFamily,
        intensity: intensity,
        ralNumber: ralNumber,
        ralName: ralName,
        ralDisplay: ralName ? `${color.title.replace(/\s*-\s*ral\s*\d+/i, '')} - ${ralName}` : null
      });
    }

    // Update family count badges
    const ralCount = allColors.filter(c => c.ralNumber).length;
    document.querySelectorAll('[data-bf-count]').forEach(el => {
      const bf = el.dataset.bfCount;
      const count = bf === 'ral' ? ralCount : allColors.filter(c => c.broadFamily === bf).length;
      el.textContent = `${count} Farben`;
    });

    checkAvailabilityAndSetDefault();
  };

  // ── Default state ──

  const checkAvailabilityAndSetDefault = () => {
    const checkInterval = setInterval(() => {
      const options = document.querySelectorAll(".CP__presigruppe-theme-select option");
      const allSet = Array.from(options).some(option =>
        option.getAttribute('data-variant-option-available') !== null
      );

      if (allSet) {
        clearInterval(checkInterval);
        updateWeissBarPrice();

        // Reorder deep-link: ?farbton=<exakter Farbton> wählt die Farbe vor und setzt
        // properties[Farbauswahl] sauber neu (aus Nachbestell-Link/E-Mail). Läuft hier,
        // sobald die Verfügbarkeits-Daten gesetzt sind, und überschreibt die Weiß-Vorwahl.
        // color.title ist exakt der in der Property gespeicherte Wert.
        const presetTitle = new URLSearchParams(location.search).get('farbton');
        if (presetTitle) {
          const preset = allColors.find(c => c.title === presetTitle);
          if (preset && isColorAvailable(preset.hbw)) {
            selectColor(preset);
            return;
          }
        }

        const weiss = allColors.find(c => c.title === 'Weiss');
        if (weiss && isColorAvailable(weiss.hbw)) {
          selectColor(weiss);
        }

        // Check if only white tier is available (e.g. 10L with no Wunschfarbton)
        // Must run AFTER selectColor since selectColor re-shows the button
        const availableOptions = Array.from(options).filter(o =>
          o.getAttribute('data-variant-option-available') === 'true'
        );
        const onlyWhite = availableOptions.length === 1 &&
          parseFloat(availableOptions[0].dataset.hbwmin) >= 85;
        if (onlyWhite) {
          onlyWhiteMode = true;
          const changeBtnCheck = document.getElementById('cp-change-btn');
          if (changeBtnCheck) changeBtnCheck.style.display = 'none';
          hidePicker();
          return;
        } else {
          onlyWhiteMode = false;
        }

        if (weiss && isColorAvailable(weiss.hbw)) {
          return;
        }

        // Fallback: first available
        for (let color of allColors) {
          if (isColorAvailable(color.hbw)) {
            selectColor(color);
            break;
          }
        }
      }
    }, 100);
  };

  const updateWeissBarPrice = () => {
    const bar = document.getElementById('cp-weiss-bar');
    if (!bar) return;
    const prices = getTierPrices();
    let priceEl = bar.querySelector('.CP__weiss-price');
    if (prices.weiss) {
      const priceStr = formatPrice(prices.weiss);
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'CP__weiss-price';
        bar.appendChild(priceEl);
      }
      priceEl.textContent = priceStr;
    } else if (priceEl) {
      priceEl.remove();
    }
  };

  const nudgeHtml = '<span class="CP__nudge">meistgekauft</span>';

  const updateDefaultDisplay = (color) => {
    const swatch = document.getElementById('cp-default-swatch');
    const label = document.getElementById('cp-default-label');
    const quickWeiss = document.getElementById('cp-quick-weiss');
    if (swatch) {
      swatch.style.background = color.hex;
      swatch.style.borderColor = color.hex === '#ffffff' ? '#ddd' : color.hex;
    }
    if (label) {
      let displayName = color.ralDisplay || color.title;
      const isWeiss = color.title === 'Weiss';
      if (isWeiss) displayName = 'Weiß';
      label.innerHTML = isWeiss ? `${displayName} ${nudgeHtml}` : displayName;
    }
    const isWeiss = color.title === 'Weiss';
    if (quickWeiss) {
      quickWeiss.style.display = isWeiss ? 'none' : 'flex';
    }
    const changeBtn = document.getElementById('cp-change-btn');
    if (changeBtn) {
      // Don't show button if only white tier is available for current size
      const opts = document.querySelectorAll(".CP__presigruppe-theme-select option");
      const avail = Array.from(opts).filter(o => o.getAttribute('data-variant-option-available') === 'true');
      const onlyWhiteTier = avail.length === 1 && parseFloat(avail[0].dataset.hbwmin) >= 85;
      changeBtn.style.display = (isWeiss && !onlyWhiteTier) ? 'flex' : 'none';
    }
  };

  // ── Picker visibility ──

  const showPicker = () => {
    if (pickerPanel) pickerPanel.style.display = 'block';
    pickerVisible = true;
    const btn = document.getElementById('cp-change-btn');
    if (btn) btn.style.display = 'none';
    // Always hide weiss-bar inside picker — Weiß is accessible from default state above
    const weissBarEl = document.getElementById('cp-weiss-bar');
    if (weissBarEl) weissBarEl.style.display = 'none';
    // Clear search fields
    const s3 = document.getElementById('cp-step3-search');
    if (s3) s3.value = '';
    // Resume from last step if user already made selections
    if (currentIntensity && currentBroadFamily) {
      showStep(3);
      populateColorList();
    } else if (currentBroadFamily) {
      showStep(2);
      buildIntensityStep(currentBroadFamily);
    } else {
      showStep(1);
    }
  };

  let onlyWhiteMode = false;

  const hidePicker = () => {
    if (pickerPanel) pickerPanel.style.display = 'none';
    pickerVisible = false;
    // Only show change button if Weiß is selected AND other tiers exist
    const btn = document.getElementById('cp-change-btn');
    const isWeiss = selectedColor && selectedColor.title === 'Weiss';
    if (btn) btn.style.display = (isWeiss && !onlyWhiteMode) ? '' : 'none';
  };

  const showStep = (step) => {
    // Accordion: only the active step's content is visible
    if (step1) step1.style.display = step === 1 ? 'block' : 'none';
    if (step2) step2.style.display = step === 2 ? 'block' : 'none';
    if (step3) step3.style.display = step === 3 ? 'block' : 'none';
    // Update step headers
    document.querySelectorAll('.CP__step-header').forEach(h => {
      const s = parseInt(h.dataset.step);
      h.classList.toggle('is-active', s === step);
      h.classList.toggle('is-done', s < step);
      // Hide future step headers that haven't been reached yet
      h.style.display = s <= step ? '' : 'none';
    });
  };

  // ── Step 1: Select broad family ──

  const selectBroadFamily = (bf) => {
    currentBroadFamily = bf;
    currentIntensity = null;

    // Update selected state
    document.querySelectorAll('.CP__bf-item').forEach(item => {
      item.classList.toggle('is-selected', item.dataset.family === bf);
    });

    // Show selection in step 1 header
    const step1Header = document.getElementById('cp-step1-header');
    const step1Title = step1Header ? step1Header.querySelector('.CP__step-title') : null;
    const familyLabel = bf === 'ral' ? 'RAL' : (broadFamilyNames[bf] || bf);
    const gradient = broadFamilyGradients[bf] || '';
    if (step1Title) step1Title.textContent = `Farbfamilie: ${familyLabel}`;
    // Swap: swatch takes the left (step-num) position, step-num goes right
    if (step1Header && gradient) {
      const stepNum = step1Header.querySelector('.CP__step-num');
      let swatch = step1Header.querySelector('.CP__step-swatch');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'CP__step-swatch';
      }
      swatch.style.background = gradient;
      // Insert swatch at the start (before step-num), move step-num to end
      step1Header.insertBefore(swatch, stepNum);
      step1Header.appendChild(stepNum);
    }

    showStep(2);
    buildIntensityStep(bf);
  };

  // ── Step 2: Select intensity ──

  const buildIntensityStep = (bf) => {
    const container = document.getElementById('cp-intensity-buttons');
    if (!container) return;
    container.innerHTML = '';

    const isRal = bf === 'ral';
    const familyColors = isRal
      ? allColors.filter(c => c.ralNumber)
      : allColors.filter(c => c.broadFamily === bf);

    const tiers = ['hell', 'mittel', 'dunkel'];
    const prices = getTierPrices();

    tiers.forEach(tier => {
      const colorsInTier = familyColors.filter(c => c.intensity === tier);
      const count = colorsInTier.length;
      const available = colorsInTier.some(c => isColorAvailable(c.hbw));

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'CP__intensity-btn';
      if (count === 0) btn.classList.add('is-empty');
      if (!available && count > 0) btn.classList.add('is-unavailable');
      btn.dataset.intensity = tier;

      const priceStr = prices[tier] ? formatDelta(prices[tier], prices.weiss) : '';

      btn.innerHTML = `
        <span class="CP__intensity-name">${intensityNames[tier]}</span>
        <span class="CP__intensity-count">${count} Farben</span>
        ${priceStr ? `<span class="CP__intensity-price">${priceStr}</span>` : ''}
      `;

      if (count > 0 && available) {
        btn.addEventListener('click', () => selectIntensity(tier));
      }

      container.appendChild(btn);
    });
  };

  const selectIntensity = (tier) => {
    currentIntensity = tier;

    document.querySelectorAll('.CP__intensity-btn').forEach(btn => {
      btn.classList.toggle('is-selected', btn.dataset.intensity === tier);
    });

    // Show selection in step 2 header
    const step2Title = document.querySelector('#cp-step2-header .CP__step-title');
    if (step2Title) step2Title.textContent = `Farbintensität: ${intensityNames[tier]}`;

    showStep(3);
    populateColorList();
  };

  // ── Step 3: Color list ──

  const populateColorList = (searchTerm = '') => {
    if (!colorList) return;

    const isRal = currentBroadFamily === 'ral';
    let filtered;

    if (isRal) {
      filtered = allColors.filter(c => c.ralNumber && c.intensity === currentIntensity);
    } else {
      filtered = allColors.filter(c => c.broadFamily === currentBroadFamily && c.intensity === currentIntensity);
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(c =>
        c.title.toLowerCase().includes(term) ||
        (c.ralDisplay && c.ralDisplay.toLowerCase().includes(term)) ||
        (c.ralName && c.ralName.toLowerCase().includes(term))
      );
    }

    colorList.innerHTML = '';
    const scrollContainer = colorList.closest('.CP__color-scroll');
    if (scrollContainer) scrollContainer.scrollTop = 0;

    // Show RAL colors first
    const ralColors = filtered.filter(c => c.ralNumber);
    const nonRalColors = filtered.filter(c => !c.ralNumber);

    if (ralColors.length > 0 && !isRal && !searchTerm) {
      const label = document.createElement('li');
      label.className = 'CP__color-list__label';
      label.textContent = `Klassische Farben / RAL (${ralColors.length})`;
      colorList.appendChild(label);
      ralColors.forEach(c => colorList.appendChild(createColorItem(c)));

      if (nonRalColors.length > 0) {
        const sep = document.createElement('li');
        sep.className = 'CP__color-list__label';
        sep.textContent = `Weitere Farbtöne (${nonRalColors.length})`;
        colorList.appendChild(sep);
      }
    }

    const mainList = (ralColors.length > 0 && !isRal && !searchTerm) ? nonRalColors : filtered;
    if (mainList.length === 0 && ralColors.length === 0) {
      colorList.innerHTML = '<li class="CP__no-colors">Keine Farben gefunden</li>';
      return;
    }

    mainList.forEach(c => colorList.appendChild(createColorItem(c)));

    // Update step 3 header count
    const step3Count = document.getElementById('cp-step3-count');
    if (step3Count) step3Count.textContent = `(${filtered.length})`;
  };

  const createColorItem = (color) => {
    const li = document.createElement('li');
    li.className = 'CP__color-item';
    li.style.background = color.hex;
    const brightness = getBrightness(color.hex);
    li.style.color = brightness > 128 ? '#333' : '#fff';
    if (brightness <= 128) li.classList.add('is-dark');

    const isAvailable = isColorAvailable(color.hbw);
    if (!isAvailable) li.classList.add('is-unavailable');
    if (selectedColor && selectedColor.title === color.title) li.classList.add('is-current');

    const displayName = color.ralDisplay || color.title;
    li.innerHTML = `<span>${displayName}</span>`;

    li.addEventListener('click', () => {
      if (!isAvailable) return;
      selectColor(color, false, true);
    });

    return li;
  };

  // ── Select color ──

  const selectColor = (color, silent = false, userInitiated = false) => {
    isSelectingColor = true;
    selectedColor = color;

    if (colorPicker) colorPicker.value = color.title;

    updateDefaultDisplay(color);
    setSelectValue(color.title, color.hbw, silent);
    const matchedVariant = findMatchedVariantForColor(color);
    if (matchedVariant) updatePriceDisplay(matchedVariant);
    updateGalleryColor(color.hex);
    setSelectedGalleryPosition(1);

    // Hide picker after selection
    hidePicker();

    // On mobile, scroll up to gallery so user sees the color applied — only on real user picks.
    // Init/system calls (default Weiss preselect, size-change reset, onlyWhiteAvailable) skip
    // this so they don't yank the page down on multi-section layouts (e.g. homepage featured-product).
    if (userInitiated && window.innerWidth <= 768) {
      const gallery = document.querySelector('.product-gallery--image-background');
      if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setTimeout(() => { isSelectingColor = false; }, 200);
  };

  // ── Gallery helpers ──

  const updateGalleryColor = (hexColor) => {
    const galleryBackgrounds = document.querySelectorAll(".product-gallery--image-background");
    galleryBackgrounds.forEach((element) => {
      element.style.backgroundColor = hexColor;
    });
    document.documentElement.style.setProperty('--wunschfarbton-bg', hexColor);
    document.documentElement.classList.add('has-wunschfarbton');
  };

  const setSelectedGalleryPosition = (position) => {
    const thumbnails = document.querySelectorAll(".product-gallery--media-thumbnail");
    if (thumbnails.length > position) {
      const targetThumbnail = thumbnails[position];
      if (targetThumbnail) {
        setTimeout(() => {
          thumbnails.forEach((thumb) => thumb.removeAttribute("data-gallery-selected"));
          targetThumbnail.setAttribute("data-gallery-selected", "true");
          thumbnails.forEach((thumb) => thumb.classList.remove("active"));
          targetThumbnail.classList.add("active");
          targetThumbnail.dispatchEvent(new Event("mousedown", { bubbles: true }));
          targetThumbnail.dispatchEvent(new Event("mouseup", { bubbles: true }));
          targetThumbnail.click();
        }, 10);
      }
    }
  };

  // ── Search (bypasses steps) ──

  const setupSearch = () => {
    if (!searchInput || !searchResults) return;

    let searchTimeout = null;
    const MAX_RESULTS = 30;

    const clearResults = () => { searchResults.innerHTML = ''; };

    const pickColorFromSearch = (color) => {
      // Reset step state so re-opening picker starts fresh
      currentBroadFamily = null;
      currentIntensity = null;
      const step1Header = document.getElementById('cp-step1-header');
      const step1Title = step1Header ? step1Header.querySelector('.CP__step-title') : null;
      if (step1Title) step1Title.textContent = 'Farbfamilie wählen';
      const step1Swatch = step1Header ? step1Header.querySelector('.CP__step-swatch') : null;
      if (step1Swatch) step1Swatch.remove();
      // Restore step-num to the left
      const stepNum1 = step1Header ? step1Header.querySelector('.CP__step-num') : null;
      if (step1Header && stepNum1) step1Header.insertBefore(stepNum1, step1Header.firstChild);
      const step2Title = document.querySelector('#cp-step2-header .CP__step-title');
      if (step2Title) step2Title.textContent = 'Farbintensität wählen';
      selectColor(color, false, true);
      searchInput.value = '';
      clearResults();
    };

    const showSearchResults = (term) => {
      clearResults();
      if (!term) return;
      const t = term.toLowerCase();

      // Exact Brillux code match → auto-select
      const exact = allColors.find(c => c.title.toLowerCase() === t || c.title.toLowerCase().startsWith(t + ' -'));
      if (exact && isColorAvailable(exact.hbw)) {
        pickColorFromSearch(exact);
        return;
      }

      const matches = allColors.filter(c =>
        c.title.toLowerCase().includes(t) ||
        (c.ralDisplay && c.ralDisplay.toLowerCase().includes(t)) ||
        (c.ralName && c.ralName.toLowerCase().includes(t))
      ).slice(0, MAX_RESULTS);

      if (matches.length === 0) {
        const li = document.createElement('li');
        li.className = 'CP__search-results__empty';
        li.textContent = 'Keine Farbe gefunden';
        searchResults.appendChild(li);
        return;
      }

      matches.forEach(color => {
        const li = document.createElement('li');
        li.style.background = color.hex;
        const brightness = getBrightness(color.hex);
        li.style.color = brightness > 128 ? '#333' : '#fff';
        if (brightness <= 128) li.classList.add('is-dark');
        const available = isColorAvailable(color.hbw);
        if (!available) { li.style.opacity = '0.5'; li.style.cursor = 'not-allowed'; }
        const label = color.ralDisplay || color.title;
        li.innerHTML = `<span>${label}${!available ? ' (ausverkauft)' : ''}</span>`;
        li.addEventListener('click', (e) => {
          e.stopPropagation();
          if (!available) return;
          pickColorFromSearch(color);
        });
        searchResults.appendChild(li);
      });
    };

    searchInput.addEventListener("input", (e) => {
      clearTimeout(searchTimeout);
      const term = e.target.value.trim();
      if (!term) { clearResults(); return; }
      searchTimeout = setTimeout(() => showSearchResults(term), 300);
    });

    searchInput.addEventListener("keydown", (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(searchTimeout);
        showSearchResults(searchInput.value.trim());
      }
    });

    searchInput.addEventListener("click", (e) => e.stopPropagation());
  };

  // ── Event handlers ──

  // "Andere Farbe wählen" button
  const changeBtn = document.getElementById('cp-change-btn');
  if (changeBtn) {
    changeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      showPicker();
    });
  }

  // Selected color card — tap to reopen picker (only when a custom color is selected, not Weiß)
  const selectedCard = document.getElementById('cp-default-selected');
  if (selectedCard) {
    selectedCard.addEventListener('click', (e) => {
      e.preventDefault();
      if (selectedColor && selectedColor.title !== 'Weiss') {
        showPicker();
      }
    });
  }

  // Close button
  const closeBtn = document.getElementById('cp-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      hidePicker();
    });
  }

  // Weiß quick-select bar
  const weissBar = document.getElementById('cp-weiss-bar');
  if (weissBar) {
    weissBar.addEventListener('click', (e) => {
      e.stopPropagation();
      const weiss = allColors.find(c => c.title === 'Weiss');
      if (weiss) {
        currentBroadFamily = null;
        currentIntensity = null;
        // Reset step 1 header DOM
        const s1h = document.getElementById('cp-step1-header');
        const s1Title = s1h ? s1h.querySelector('.CP__step-title') : null;
        if (s1Title) s1Title.textContent = 'Farbfamilie wählen';
        const s1Swatch = s1h ? s1h.querySelector('.CP__step-swatch') : null;
        if (s1Swatch) s1Swatch.remove();
        const s1Num = s1h ? s1h.querySelector('.CP__step-num') : null;
        if (s1h && s1Num) s1h.insertBefore(s1Num, s1h.firstChild);
        // Reset step 2 header
        const s2Title = document.querySelector('#cp-step2-header .CP__step-title');
        if (s2Title) s2Title.textContent = 'Farbintensität wählen';
        // Clear family button selection
        document.querySelectorAll('.CP__bf-item').forEach(i => i.classList.remove('is-selected'));
        selectColor(weiss, false, true);
      }
    });
  }

  // Quick Weiß button (outside picker, in default state)
  const quickWeiss = document.getElementById('cp-quick-weiss');
  if (quickWeiss) {
    quickWeiss.addEventListener('click', () => {
      const weiss = allColors.find(c => c.title === 'Weiss');
      if (weiss) {
        currentBroadFamily = null;
        currentIntensity = null;
        document.querySelectorAll('.CP__bf-item').forEach(i => i.classList.remove('is-selected'));
        selectColor(weiss, false, true);
      }
    });
  }

  // Broad family clicks
  document.querySelectorAll('.CP__bf-item').forEach(item => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      selectBroadFamily(item.dataset.family);
    });
  });

  // Step headers (click done headers to go back — ignore clicks on active header)
  document.querySelectorAll('.CP__step-header').forEach(header => {
    header.addEventListener('click', () => {
      if (!header.classList.contains('is-done')) return;
      const step = parseInt(header.dataset.step);
      if (step === 1) {
        currentBroadFamily = null;
        currentIntensity = null;
        // Reset header titles and restore step-num position
        const s1h = document.getElementById('cp-step1-header');
        const step1Title = s1h ? s1h.querySelector('.CP__step-title') : null;
        if (step1Title) step1Title.textContent = 'Farbfamilie wählen';
        const step1Swatch = s1h ? s1h.querySelector('.CP__step-swatch') : null;
        if (step1Swatch) step1Swatch.remove();
        const sn1 = s1h ? s1h.querySelector('.CP__step-num') : null;
        if (s1h && sn1) s1h.insertBefore(sn1, s1h.firstChild);
        const step2Title = document.querySelector('#cp-step2-header .CP__step-title');
        if (step2Title) step2Title.textContent = 'Farbintensität wählen';
        showStep(1);
        document.querySelectorAll('.CP__bf-item').forEach(i => i.classList.remove('is-selected'));
      } else if (step === 2 && currentBroadFamily) {
        currentIntensity = null;
        // Reset step 2 header title
        const step2Title = document.querySelector('#cp-step2-header .CP__step-title');
        if (step2Title) step2Title.textContent = 'Farbintensität wählen';
        showStep(2);
        document.querySelectorAll('.CP__intensity-btn').forEach(b => b.classList.remove('is-selected'));
      }
    });
  });

  // Step 3 search
  const step3Search = document.getElementById('cp-step3-search');
  if (step3Search) {
    step3Search.addEventListener("input", (e) => {
      populateColorList(e.target.value);
    });
    step3Search.addEventListener("click", (e) => e.stopPropagation());
  }

  // Click outside to close picker
  document.addEventListener("click", (e) => {
    const wrapper = document.querySelector('.CP__wrapper');
    if (pickerVisible && wrapper && !wrapper.contains(e.target)) {
      hidePicker();
    }
  });

  // Only white available
  document.addEventListener("onlyWhiteAvailable", () => {
    if (isSelectingColor) return;

    onlyWhiteMode = true;
    hidePicker();
    const changeBtn = document.getElementById('cp-change-btn');
    if (changeBtn) changeBtn.style.display = 'none';

    const whiteColor = allColors.find(c => c.title === 'Weiss');
    if (whiteColor) {
      selectColor(whiteColor, true);
    }
  });

  // Reset color selection (fired on size/liter change)
  document.addEventListener("resetColorSelection", () => {
    if (isSelectingColor) return;

    // Show "Andere Farbe wählen" button again (may have been hidden by onlyWhiteAvailable)
    onlyWhiteMode = false;
    const changeBtn = document.getElementById('cp-change-btn');
    if (changeBtn) changeBtn.style.display = '';

    // Preserve current color selection across size changes
    if (selectedColor) {
      // Re-check availability with new size
      if (isColorAvailable(selectedColor.hbw)) {
        selectColor(selectedColor, false);
      } else {
        // Color tier not available at new size, fall back to Weiss
        const weiss = allColors.find(c => c.title === 'Weiss');
        if (weiss && isColorAvailable(weiss.hbw)) {
          selectColor(weiss, false);
        }
      }
      // Rebuild intensity step if picker is open (prices change with size)
      if (pickerVisible && currentBroadFamily) {
        buildIntensityStep(currentBroadFamily);
      }
      updateWeissBarPrice();
      return;
    }

    // Coming from only-white mode — reset to default Weiß
    selectedColor = null;
    currentBroadFamily = null;
    currentIntensity = null;
    hidePicker();
    checkAvailabilityAndSetDefault();
  });

  // ── Initialize ──
  setupSearch();
  loadColors();
});
